(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-discounts"]) return;
  try {
    
  function resizeSpacer() {
    $('#description_spacer').height($('#description_block').outerHeight());
  }

  $(document).on('click', '.description_more a', function() {
    var $description_block = $('#description_block');
    if ($description_block.length) {
      $description_block.removeClass('crop');
      $(this).parent().hide();
      resizeSpacer();
    }
  });

  var $window = $(window);
  var windowWidth = $window.width();
  $window.resize(function() {
    var $description_block = $('#description_block');
    if ($description_block.length && !$description_block.hasClass('crop')) {
      var width = $window.width();
      if (width != windowWidth) {
        resizeSpacer();
        windowWidth = width;
      }
    }
  });

  $('body').on('click', '.filter-item', function() {
    window.location.href = $(this).attr('data-value');
  });

  $('.filterTrigger').on('click', function() {
    $('body').addClass('filter-shown');
  });

  $('.filter-list-wrapper').on('click', function(e) {
    if ($(e.target).is('.filter-list-wrapper')) {
      $('body').removeClass('filter-shown');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-guns"]) return;
  try {
    

function resizeSpacer() {
  $('#description_spacer').height($('#description_block').outerHeight());
}

$(document).on('click', '.description_more a', function() {
  var $description_block = $('#description_block');
  if ($description_block.length) {
    $description_block.removeClass('crop');
    $(this).parent().hide();
    resizeSpacer();
  }
});

var $window = $(window);
var windowWidth = $window.width();
$window.resize(function() {
  var $description_block = $('#description_block');
  if ($description_block.length && !$description_block.hasClass('crop')) {
    var width = $window.width();
    if (width != windowWidth) {
      resizeSpacer();
      windowWidth = width;
    }
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-manufacturer"]) return;
  try {
    
function resizeSpacer() {
  $('#description_spacer').height($('#description_block').outerHeight());
}

$(document).on('click', '.description_more a', function() {
  var $description_block = $('#description_block');
  if ($description_block.length) {
    $description_block.removeClass('crop');
    $(this).parent().hide();
    resizeSpacer();
  }
});

var $window = $(window);
var windowWidth = $window.width();
$window.resize(function() {
  var $description_block = $('#description_block');
  if ($description_block.length && !$description_block.hasClass('crop')) {
    var width = $window.width();
    if (width != windowWidth) {
      resizeSpacer();
      windowWidth = width;
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-template"]) return;
  try {
    
  function resizeSpacer() {
    $('#description_spacer').height($('.collection__description').outerHeight());
  }

  $(document).on('click', '.description_more a', function() {
    var $description_block = $('#description_block');
    if ($description_block.length) {
      $description_block.removeClass('crop');
      $(this).parent().hide();
      resizeSpacer();
    }
  });

  resizeSpacer();

  var $window = $(window);
  var windowWidth = $window.width();
  $window.resize(function() {
    var $description_block = $('#description_block');
    if ($description_block.length) {
      var width = $window.width();
      if (width != windowWidth) {
        resizeSpacer();
        windowWidth = width;
      }
    }
  });

  $('body').on('click', '.filter-item', function() {
    window.location.href = $(this).attr('data-value');
  });

  $('.filterTrigger').on('click', function() {
    $('body').addClass('filter-shown');
  });

  $('.filter-list-wrapper').on('click', function(e) {
    if ($(e.target).is('.filter-list-wrapper')) {
      $('body').removeClass('filter-shown');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-variants"]) return;
  try {
    
function resizeSpacer() {
  $('#description_spacer').height($('#description_block').outerHeight());
}

$(document).on('click', '.description_more a', function() {
  var $description_block = $('#description_block');
  if ($description_block.length) {
    $description_block.removeClass('crop');
    $(this).parent().hide();
    resizeSpacer();
  }
});

var $window = $(window);
var windowWidth = $window.width();
$window.resize(function() {
  var $description_block = $('#description_block');
  if ($description_block.length && !$description_block.hasClass('crop')) {
    var width = $window.width();
    if (width != windowWidth) {
      resizeSpacer();
      windowWidth = width;
    }
  }
});

$('body').on('click', '.filter-item', function() {
  window.location.href = $(this).attr('data-value');
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-collection"]) return;
  try {
    
  function resizeSpacer() {
    $('#description_spacer').height($('#description_block').outerHeight());
  }

  $(document).on('click', '.description_more a', function() {
    var $description_block = $('#description_block');
    if ($description_block.length) {
      $description_block.removeClass('crop');
      $(this).parent().hide();
      resizeSpacer();
    }
  });

  var $window = $(window);
  var windowWidth = $window.width();
  $window.resize(function() {
    var $description_block = $('#description_block');
    if ($description_block.length && !$description_block.hasClass('crop')) {
      var width = $window.width();
      if (width != windowWidth) {
        resizeSpacer();
        windowWidth = width;
      }
    }
  });

  /*$('.filterlist-header').on('click', function() {
    if ($('.filterlist-wrapper').hasClass('open')) {
      $('.filterlist-wrapper').removeClass('open').slideUp();
      $('.filterlist-arrow').removeClass('rotate');
      $('.filterlist-header').removeClass('open');
    } else {
      $('.filterlist-wrapper').addClass('open').slideDown();
      $('.filterlist-arrow').addClass('rotate');
      $('.filterlist-header').addClass('open');
    }
  });

  $('.filterlist-checkboxes input:checkbox').on('change', function() {
    if (!$('.filterlist-checkboxes input:checkbox:checked').length) {
      $('.collection-grid-item').parent().show();
      return;
    } else {
      var a = $('.filterlist-checkboxes input:checkbox:checked').map(function() {
        return $(this).val();
      }).get();
      $('.collection-grid-item').parents().hide();
      let products = $('.collection-grid-item').filter(function() {
        let product = $(this).find('h2.collection-grid-item__title')[0].childNodes[0].nodeValue.trim();
        let index = $.inArray(product, a);
        return index >= 0;
      }).parents().show();
    }
  });

  $('.filterfield-search-input').on('keyup touchend', function() {
    if (!$('.filterfield-search-input').val().length) {
      $('.collection-grid-item').parent().show();
      return;
    } else {
      let userInput = $('.filterfield-search-input').val().toLowerCase();
      let products = $('.collection-grid-item').map(function() {
        let product = $(this).find('h2.collection-grid-item__title')[0].childNodes[0].nodeValue.trim().toLowerCase();
        if (product.indexOf(userInput) > -1) {
          $(this).parent().show();
          return;
        } else {
          $(this).parent().hide();
        }
      });
    }
  });*/

  const searchParams = new URLSearchParams(window.location.search);

  if (searchParams.has('promo')) {
    $('.promo-' + searchParams.get('promo')).show();
  }
  

  } catch(e) { console.error(e); }
})();
})();
